import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import "../styles/SecurityCenter.css";

const SecurityCenter = () => {
    const { currentUser } = useAuth();
    const [loginHistory, setLoginHistory] = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(true);
    const [historyError, setHistoryError] = useState("");

    useEffect(() => {
        const loadLoginHistory = async () => {
            try {
                setLoadingHistory(true);
                setHistoryError("");

                const res = await api.get("/api/security/login-history");
                setLoginHistory(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error("Failed to load login history:", err);
                setHistoryError("Failed to load login history.");
            } finally {
                setLoadingHistory(false);
            }
        };

        loadLoginHistory();
    }, []);

    const handleLogoutAllSessions = async () => {
        try {
            await api.post("/api/sessions/logout-all");
            alert("All other sessions have been logged out.");
        } catch (err) {
            console.error("Failed to log out other sessions:", err);
            alert("Failed to log out other sessions.");
        }
    };

    return (
        <div className="security-center-page">
            <div className="security-center-header">
                <h1>Security Center</h1>
                <p>Manage account access, sessions, and sign-in activity.</p>
            </div>

            <div className="security-center-grid">
                <section className="security-card">
                    <h2>Account Security</h2>
                    <div className="security-detail"><strong>Name:</strong> {currentUser?.name || "—"}</div>
                    <div className="security-detail"><strong>Email:</strong> {currentUser?.email || "—"}</div>
                    <div className="security-detail"><strong>Role:</strong> {currentUser?.role || "—"}</div>
                    <div className="security-detail">
                        <strong>Two-Factor Authentication:</strong> {currentUser?.twoFactorEnabled ? "Enabled" : "Not enabled"}
                    </div>
                    <div className="security-detail">
                        <strong>Passkey:</strong> Coming soon
                    </div>
                </section>

                <section className="security-card">
                    <div className="security-card-header">
                        <h2>Active Sessions</h2>
                        <button className="security-btn" onClick={handleLogoutAllSessions}>
                            Log Out Other Sessions
                        </button>
                    </div>
                    <p className="security-muted">
                        Session controls are active. Per-device session management can be added next.
                    </p>
                </section>

                <section className="security-card security-card-wide">
                    <h2>Recent Login Activity</h2>

                    {loadingHistory ? (
                        <p className="security-muted">Loading login history...</p>
                    ) : historyError ? (
                        <p className="security-error">{historyError}</p>
                    ) : loginHistory.length === 0 ? (
                        <p className="security-muted">No login activity found.</p>
                    ) : (
                        <div className="security-history-list">
                            {loginHistory.map((entry) => (
                                <div key={entry._id} className="security-history-item">
                                    <div>
                                        <div className="security-history-title">
                                            {entry.userAgent || "Unknown device"}
                                        </div>
                                        <div className="security-history-meta">
                                            IP: {entry.ip || "Unknown"}
                                        </div>
                                    </div>
                                    <div className="security-history-time">
                                        {entry.createdAt ? new Date(entry.createdAt).toLocaleString() : "—"}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </section>

                <section className="security-card security-card-wide">
                    <h2>Invite Activity</h2>
                    <p className="security-muted">
                        Invite history panel coming next. This will show sent, accepted, and expired invites.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default SecurityCenter;